let storeContent = generateStore({
   loading: false,
   show: false,
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
   }
};

function generateStore(data) {
   let state = {}, getters = {}, mutations = {}

   for (const [key, obj] of Object.entries(data)) {
      state[key] = obj
      getters[key] = state => { return state[key] }
      mutations[key] = (state, content) => { state[key] = content }
   }

   return { state, getters, mutations }
}